import { render, staticRenderFns } from "./Emoji.vue?vue&type=template&id=2c58517f&scoped=true&"
import script from "./Emoji.vue?vue&type=script&lang=ts&"
export * from "./Emoji.vue?vue&type=script&lang=ts&"
import style0 from "./Emoji.vue?vue&type=style&index=0&id=2c58517f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58517f",
  null
  
)

export default component.exports